import feasibilityImg from "../../../assets/images/service/site-fesiablity.png";
import {
  Settings,
  Zap,
  FileCheck,
  ShieldCheck,
  Search,
  Map,
  TrendingUp,
  Maximize,
  UserCheck,
  BarChart4,
  ClipboardCheck
} from "lucide-react";
import ServiceSidebar from "../sidebar";

export default function SiteFeasibility() {
  return (
    <>
      <section className="service-detail py-10">
        <div className="container">
          <div className="service-detail-inner">
            {/* Feature Section */}
            <div className="service-feature mb-8">
              <div className="row align-items-center gy-5">
                {/* Content */}
                <div className="col-lg-6 px-8 feature-content">
                  <h2 className="fw-bold mb-2">
                    Expert <span className="green">Site Feasibility Studies</span> & Due Diligence
                  </h2>
                  <p className="mb-4">
                    Denial Enterprise provides comprehensive site assessments to determine the technical, 
                    financial, and regulatory viability of your energy and infrastructure projects.
                  </p>

                  <div className="feature-points">
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Technical site surveys & load demand analysis</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Grid connectivity & utility infrastructure assessment</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Regulatory mapping & statutory risk evaluation</span>
                    </div>
                  </div>
                </div>
                {/* Image */}
                <div className="col-lg-6">
                  <div className="feature-image position-relative">
                    <img
                      src={feasibilityImg}
                      alt="Site Feasibility Assessment"
                      className="w-100 rounded2 shadow"
                    />
                    <div className="image-badge">
                      <i className="fa fa-search"></i> Insight-Driven Planning
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Service Info */}
            <div className="service-info">
              <div className="row mt-6 gx-lg-5 gy-5">
                <div className="col-lg-4">
                  <ServiceSidebar />
                </div>
                {/* Left Content */}
                <div className="col-lg-8">
                  <div className="about-service mb-6">
                    <h3 className="mb-2">About the Service</h3>
                    <p className="mb-3">
                      Before capital is deployed, a project’s success depends on the precision of its feasibility study. Denial Enterprise bridges the gap between vision and execution by conducting on-ground surveys that evaluate power availability, civil constraints, and logistical accessibility.
                    </p>
                    <p className="mb-3">
                      Our studies include detailed "Town Planning" (Nagar Niyojan) reviews, environmental impact screenings, and cost-benefit analyses, ensuring that your EVCS, CBG, or industrial site is built on a compliant and sustainable foundation.
                    </p>

                    <ul className="icon-list-modern icon-list list-unstyled">
                      <li>
                        <span className="icon-wrap">
                          <Map size={22} />
                        </span>
                        <span>Geographical Survey & Land Use Analysis</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <BarChart4 size={22} />
                        </span>
                        <span>Electrical Load Feasibility & Grid Capacity Study</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <ClipboardCheck size={22} />
                        </span>
                        <span>Liaison with Authorities for Preliminary Clearances</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Search size={22} />
                        </span>
                        <span>Site Constraint & Environmental Risk Identification</span>
                      </li>
                    </ul>
                  </div>

                  {/* Benefits */}
                  <div className="service-benefit">
                    <h4 className="mb-3">The Value of Precision</h4>
                    <p className="mb-6">
                      A robust feasibility report from Denial Enterprise minimizes project delays and prevents costly mid-execution design changes. We provide the data you need to make informed investment decisions.
                    </p>
                    <ul className="icon-list-modern benefit-list">
                      <li>
                        <span className="icon-wrap">
                          <ShieldCheck size={22} />
                        </span>
                        <span>Risk mitigation before financial commitment</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <TrendingUp size={22} />
                        </span>
                        <span>Accurate CAPEX and OPEX forecasting</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Maximize size={22} />
                        </span>
                        <span>Optimal site selection for maximum scalability</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <FileCheck size={22} />
                        </span>
                        <span>Clear roadmap for statutory and utility approvals</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Settings size={22} />
                        </span>
                        <span>Identification of localized technical challenges</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <UserCheck size={22} />
                        </span>
                        <span>Independent, data-driven expert consultation</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}